import axios from 'axios'
import baseUrl from './baseUrl'
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { ElMessage } from 'element-plus';
import router from '@/router';

const api = axios.create({
    baseURL: baseUrl.baseURL,
})
  
api.interceptors.request.use(config => {
    if (window.localStorage.getItem('encodedAuth_app1')) {
        config.headers['Authorization'] = `Bearer ${window.localStorage.getItem('encodedAuth_app1')}`
    }
    // 添加 bd_vid 到查询参数中
    const bd_vid = localStorage.getItem('bd_vid'); // 从 localStorage 获取 bd_vid
    if (bd_vid) {
        if (!config.params) {
            config.params = {};
        }
        config.params.bd_vid = bd_vid; // 添加 bd_vid 到查询参数
    }
    // console.log(config)
    return config
}, error => {
    Promise.reject(error)
})
api.interceptors.response.use(config => {
    return config
}, error => {
    if (error.request.status == 0 && error.response.request.responseURL == baseUrl.baseURL + '/posts') {
        ElMessage.error('网络连接失败')
    } else {
        let url = error.response.request.responseURL
        url = url.split('?')[0]
        if (error.response.request.responseURL == baseUrl.baseURL + '/enterprise/v1/share_dic_in_use' || url == baseUrl.baseURL + '/file/download') {
            return
        }
        let json
        switch (error.response.status) {
            case 204:
                ElMessage.error(error.response.data.msg || '暂无数据')
                break
            case 500:
                if(error.response.config.responseType == 'arraybuffer'){
                    json = arrayBufferToJson(error.response.data)
                }
                ElMessage.error(json ? (json.msg || '系统异常') : (error.response.data.msg || '系统异常'))
                break
            case 404:
                ElMessage.error(error.response.data.msg || '404 Not Found')
                break
            case 400:
                json = arrayBufferToJson(error.response.data)
                ElMessage.error(json ? (json.msg || '请求失败') : (error.response.data.msg || '请求失败'))
                break
            case 402:
                ElMessage.error('没有该权限')
                break
            case 401:
                window.localStorage.removeItem("encodedAuth_app1");
                window.localStorage.removeItem("login_app1");
                router.replace('/login')
                break
            case 405:
                ElMessage.error('请求方式不被允许')
                break
            case 406:
                if(checkResolve(error.response.config)){
                    // return Promise.resolve(error.response)
                     
                    json = arrayBufferToJson(error.response.data)
                }
                ElMessage.error(json ? (json.msg || '系统异常') : (error.response.data.msg || '系统异常'))

                break
            case 410:
                // console.log(error.response.data,error.response.data.msg)
                // ElMessage.error('头像丢失，请重新上传')
                break
            case 403: {
                if (error.response.data.msg) {
                    ElMessage.error(error.response.data.msg)
                }
                break
            }
            case 413: {
                ElMessage.error('文档上传失败')
                break
            }
            case 501: {
                if (error.response.data.msg) {
                    ElMessage.error(error.response.data.msg)
                }
                break
            }
        }
    }
})
function arrayBufferToJson(buffer) {
    // 步骤1: 将ArrayBuffer转换为Uint8Array
    const uint8Array = new Uint8Array(buffer);
    
    // 步骤2: 将Uint8Array转换为字符串
    const text = new TextDecoder().decode(uint8Array);
    
    // 步骤3: 将字符串解析为JSON对象
    try {
      const json = JSON.parse(text);
      return json;
    } catch (error) {
      console.error('Failed to parse text as JSON', error);
      return null;
    }
  }
function checkResolve(response){
    if(response.url=='/misscut/website/check'||response.url=='/misscut/website/download'){
        return true
    }else {
        return false
    }
}
api.interceptors.response.use(config => {
    return config
}, error => {
    console.log(error.response)
    return Promise.resolve(error.response)
})
export default api
